import { FileAttachment } from '@/types/model/inspection-modal';
import { AttachmentRequest, AttachmentsRequest } from '@/types/request/InspectionRequests';

export interface AttachmentOperationsInput {
  attachments: FileAttachment[];
  originalAttachments?: FileAttachment[];
  uploadedFileIds?: Map<FileAttachment, number>;
}

const toAttachmentRequest = (
  attachment: FileAttachment,
  uploadedFileIds: Map<FileAttachment, number>,
  id?: number,
): AttachmentRequest => ({
  Id: id,
  Description: attachment.description ?? '',
  FileId: uploadedFileIds.get(attachment) ?? (attachment.fileId ? Number(attachment.fileId) : undefined),
  Filename: attachment.fileName ?? undefined,
  Link: attachment.link || undefined,
});

export const buildAttachmentOperations = ({
  attachments,
  originalAttachments = [],
  uploadedFileIds = new Map<FileAttachment, number>(),
}: AttachmentOperationsInput): AttachmentsRequest => {
  const originalById = new Map(
    originalAttachments
      .filter((attachment): attachment is FileAttachment & { attachmentId: number } => attachment.attachmentId !== undefined)
      .map(attachment => [attachment.attachmentId, attachment]),
  );

  const add: AttachmentRequest[] = [];
  const edit: AttachmentRequest[] = [];
  const currentIds = new Set<number>();

  for (const attachment of attachments) {
    if (attachment.attachmentId !== undefined) {
      currentIds.add(attachment.attachmentId);
      const original = originalById.get(attachment.attachmentId);
      if (
        original &&
        (attachment.description !== original.description ||
          attachment.fileId !== original.fileId ||
          attachment.fileName !== original.fileName ||
          attachment.link !== original.link)
      ) {
        edit.push(toAttachmentRequest(attachment, uploadedFileIds, attachment.attachmentId));
      }
      continue;
    }

    if (uploadedFileIds.has(attachment) || attachment.fileId || attachment.link) {
      add.push(toAttachmentRequest(attachment, uploadedFileIds));
    }
  }

  const deleted = originalAttachments
    .map(attachment => attachment.attachmentId)
    .filter((attachmentId): attachmentId is number => attachmentId !== undefined && !currentIds.has(attachmentId));

  return { Add: add, Edit: edit, Delete: deleted };
};
